import React, { useEffect, useMemo } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import {
  useGetRfidMasterByIdQuery,
  useUpdateRfidMasterMutation,
} from "../toolkitServices/rfidMasterApi";
import RfidMasterForm from "../components/RfidMasterForm";

const EditRfidMaster = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    data: details,
    isLoading: isDetailsLoading,
    error: detailsError,
  } = useGetRfidMasterByIdQuery(id, { skip: !id });

  const [updateRfidMaster, { isLoading: isUpdating, isSuccess, error }] =
    useUpdateRfidMasterMutation();

  const defaultValues = useMemo(
    () => ({
      rfidCode: details?.data?.rfidCode || "",
      epcCode: details?.data?.epcCode || "",
    }),
    [details]
  );

  useEffect(() => {
    if (isSuccess) {
      toast.success("RFID Master updated!");
      navigate("/organisation/rfid-master/list");
    }
  }, [isSuccess, navigate]);

  useEffect(() => {
    const err = error || detailsError;
    if (err) {
      const msg =
        err?.data?.msg ||
        err?.data?.message ||
        err?.error ||
        "Error loading/updating RFID Master!";
      toast.error(msg);
    }
  }, [error, detailsError]);

  const handleSubmit = async (payload) => {
    try {
      await updateRfidMaster({ id, ...payload }).unwrap();
    } catch {}
  };

  return (
    <RfidMasterForm
      title="Edit RFID Master"
      subtitle="Update RFID to EPC mapping."
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      isLoading={isDetailsLoading || isUpdating}
      submitLabel="Update"
      backTo="/organisation/rfid-master/list"
      showBulkActions={false}
    />
  );
};

export default EditRfidMaster;